import React from 'react';
import { TextInput } from '@client/components/common/inputs/TextInput';
import { FieldTitle } from './RedStarTitle';
import { FieldDesc } from './common';

const DEFAULT_COLORS = [
  '#6367EF',
  '#7C7FD8',
  '#B390CF',
  '#BF6502',
  '#D4832A',
  '#F8B24C',
  '#5F5041',
  '#8D7862',
  '#C7A887',
  '#D85265',
  '#DB7D8B',
  '#DE919D',
  '#904D3D',
  '#A66B5D',
  '#C19085',
  '#57773A',
  '#6C8650',
  '#90A064',
  '#378582',
  '#63A9A2',
  '#79BAAE',
  '#3C6799',
  '#5F91C9',
  '#8ABBEC',
  '#43924A',
  '#66B16D',
  '#88CC8E',
  '#455057',
  '#6D7479',
  '#9CA1A5',
];

export const ColorPicker = ({
  value,
  onChange,
  error,
  colors = DEFAULT_COLORS,
  disableHex = false,
  disableLabels = false,
  borderColor = 'transparent',
}: {
  value: string;
  onChange: (c: string) => void;
  error?: boolean;
  colors?: string[];
  disableHex?: boolean;
  disableLabels?: boolean;
  borderColor?: string;
}) => {
  const upperCaseValue = value.toUpperCase();

  const inputValue = upperCaseValue.slice(1);

  // const [inputError, setInputError] = useState(false);

  // const handleInputChange = (val: string) => {
  //   const trimmed = val.trim();
  //   if (!trimmed.length) {
  //     setInpu
  //   }
  //   if (trimmed.match(/^[0-9a-fA-F]{6}$/)) {
  //     onChange('#' + trimmed);
  //     setInputError(false);
  //   } else {
  //     setInputError(true);
  //   }
  // }

  return (
    <div className="lg:max-w-[350px]">
      {!disableLabels && (
        <div>
          <FieldTitle title="Color" />
          <FieldDesc>
            Choose one color, that represents your brand. It will apply to all
            elements on your landing page.
          </FieldDesc>
        </div>
      )}

      <ul className="flex flex-wrap m-[-5px]">
        {colors.map((color) => {
          const isActive = (color || '').toUpperCase() === upperCaseValue;
          return (
            <li
              className={`h-[30px] w-[30px] rounded-full m-[5px] cursor-pointer relative`}
              key={color}
              style={{
                backgroundColor: color,
                border:
                  (isActive ? '3px' : '0px') +
                  ' solid ' +
                  (color === borderColor ? 'black' : borderColor),
              }}
              onClick={() => onChange(color)}
            >
              {!borderColor && (
                <span
                  className={`
            absolute left-[-4px] right-[-4px] top-[-4px] bottom-[-4px] border-2 rounded-full
            ${
              color.toUpperCase() === upperCaseValue
                ? '2 opacity-100'
                : 'opacity-0'
            }
          `}
                  style={{ borderColor: color }}
                />
              )}
            </li>
          );
        })}
      </ul>
      {!disableHex && (
        <div className="pt-[20px]">
          <FieldTitle title="HEX Color" />
          <FieldDesc>Here you can put your unique brand color code</FieldDesc>
          <div className="relative">
            <TextInput
              value={inputValue}
              onChange={(val) => onChange('#' + val)}
              variant={error ? 'error' : 'gray'}
              className="w-[240px]"
              aside={'#'}
            />
            <div
              className="w-[16px] h-[16px] absolute left-[115px] top-[12px] rounded pointer-events-none"
              style={{
                backgroundColor: !error ? upperCaseValue : 'transparent',
              }}
            />
          </div>
        </div>
      )}
      {error ? <div className="text-[#6367ef] mt-2">{error}</div> : null}
    </div>
  );
};
